import '@formatjs/intl-relativetimeformat/polyfill'
import '@formatjs/intl-relativetimeformat/locale-data/en'
import '@formatjs/intl-relativetimeformat/locale-data/id'
import '@formatjs/intl-relativetimeformat/locale-data/es'
import '@formatjs/intl-relativetimeformat/locale-data/pt'
import '@formatjs/intl-relativetimeformat/locale-data/hi'
import '@formatjs/intl-relativetimeformat/locale-data/ur'
import '@formatjs/intl-relativetimeformat/locale-data/fr'
import '@formatjs/intl-relativetimeformat/locale-data/de'

import enMessages from './locales/en.json'
import idMessages from './locales/id.json'
import esMessages from './locales/es.json'
import ptBrMessages from './locales/pt-BR.json'
import hiMessages from './locales/hi.json'
import urMessages from './locales/ur.json'
import frMessages from './locales/fr.json'
import deMessages from './locales/de.json'

const localeMessages = {
  en: enMessages,
  id: idMessages,
  es: esMessages,
  'pt-BR': ptBrMessages,
  hi: hiMessages,
  ur: urMessages,
  fr: frMessages,
  de: deMessages,
}

export function getLocaleMessages (locale) {
  return localeMessages[locale] || localeMessages.en
}
